module.exports = __webpack_public_path__ + "static/media/exit-page-RGM-Hubble-3.af53e3f3.mp4";